import { EGroupedItemsType } from '~/src/services/properties';
export const ageRestrictionConfig = {
    label: {
        name: 'label',
        label: '',
        type: EGroupedItemsType.Title,
    },
    properties: {
        name: 'properties',
        items: {
            active: {
                name: 'active',
                label: 'Включить',
                type: EGroupedItemsType.Boolean,
            },
            backgroundColor: {
                name: 'backgroundColor',
                label: 'Цвет:',
                type: EGroupedItemsType.ColorPicker,
            },
            customStyles: {
                name: 'customStyles',
                order: 1,
                label: 'Расширенные CSS-стили:',
                type: EGroupedItemsType.Text,
                withBreakpoints: true,
            },
        },
    },
};
